// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'import.importDialog.stepFile': 'Arquivo',
    'import.importDialog.stepMapping': 'Mapeamento',
    'import.importDialog.stepValidation': 'Validação',
    'import.importDialog.stepResult': 'Resultado',
    'import.importDialog.toastSuccess': 'Importação concluída: {{imported}} importado(s), {{updated}} atualizado(s).',
    'import.importDialog.toastNotCompleted': 'Importação não concluída.',
    'import.importDialog.title': 'Importar {{label}}',
    'import.importDialog.dropzone': 'Arraste o arquivo aqui ou clique para escolher',
    'import.importDialog.formats': 'CSV ou XLSX',
    'import.importDialog.formatsStrict': 'CSV ou XLSX — colunas exatamente na ordem do modelo',
    'import.importDialog.headerError': 'Arquivo fora do padrão de importação.',
    'import.importDialog.expectedOrder': 'Ordem esperada: {{order}}',
    'import.importDialog.downloadTemplateLabel': 'Baixar modelo de importação:',
    'import.importDialog.historyTitle': 'Histórico de importações',
    'import.importDialog.colDate': 'Data',
    'import.importDialog.colUser': 'Usuário',
    'import.importDialog.colFile': 'Arquivo',
    'import.importDialog.colImported': 'Importados',
    'import.importDialog.colUpdated': 'Atualizados',
    'import.importDialog.colIgnored': 'Ignorados',
    'import.importDialog.colRejected': 'Rejeitados',
    'import.importDialog.strictOk': 'Arquivo no padrão oficial ({{count}} colunas na ordem correta) — mapeamento aplicado automaticamente.',
    'import.importDialog.mappingHint': 'Associe cada coluna do arquivo a um campo do sistema (sugestões já aplicadas por semelhança de nome).',
    'import.importDialog.colFileColumn': 'Coluna do arquivo',
    'import.importDialog.colExample': 'Exemplo (1ª linha)',
    'import.importDialog.colSystemField': 'Campo do sistema',
    'import.importDialog.noTitle': '(sem título)',
    'import.importDialog.mapColumnAria': 'Mapear coluna {{column}}',
    'import.importDialog.searchFieldPlaceholder': 'Buscar campo…',
    'import.importDialog.optSkipColumn': 'Não importar esta coluna',
    'import.importDialog.requiredDefaultsHint': 'Campos obrigatórios sem coluna no arquivo — informe um valor padrão para todas as linhas:',
    'import.importDialog.defaultValueLabel': '{{field}} (valor padrão)',
    'import.importDialog.sumTotalRows': 'Linhas no arquivo',
    'import.importDialog.sumValid': 'Válidas',
    'import.importDialog.sumWithErrors': 'Com erro',
    'import.importDialog.sumDuplicates': 'Duplicadas',
    'import.importDialog.duplicatesLabel': 'Registros duplicados ({{label}})',
    'import.importDialog.searchStrategyPlaceholder': 'Buscar estratégia…',
    'import.importDialog.optStrategyIgnore': 'Ignorar (manter o cadastro atual)',
    'import.importDialog.optStrategyUpdate': 'Atualizar existente com os dados do arquivo',
    'import.importDialog.optStrategyNew': 'Cadastrar novo mesmo assim',
    'import.importDialog.errorReport': 'Relatório de erros',
    'import.importDialog.errorsWarning': '{{count}} linha(s) com problema não serão importadas. Corrija o arquivo ou autorize a importação apenas das válidas.',
    'import.importDialog.colRow': 'Linha',
    'import.importDialog.colField': 'Campo',
    'import.importDialog.colProblem': 'Problema',
    'import.importDialog.errorsShowing': 'Mostrando {{shown}} de {{total}} erros — baixe o relatório completo.',
    'import.importDialog.importValidOnly': 'Importar apenas as {{count}} linha(s) válida(s) e rejeitar as demais',
    'import.importDialog.previewTitle': 'Prévia do que será cadastrado',
    'import.importDialog.chipDuplicate': 'Duplicado',
    'import.importDialog.successAlert': 'Importação concluída.',
    'import.importDialog.notCompletedAlert': 'A importação não foi concluída.',
    'import.importDialog.resImported': 'Importados',
    'import.importDialog.resUpdated': 'Atualizados',
    'import.importDialog.resIgnored': 'Ignorados (duplicados)',
    'import.importDialog.resRejected': 'Rejeitados',
    'import.importDialog.downloadErrorReport': 'Baixar relatório de erros',
    'import.importDialog.validating': 'Validando…',
    'import.importDialog.validateData': 'Validar dados',
    'import.importDialog.importing': 'Importando…',
    'import.importDialog.confirmImport': 'Confirmar importação ({{count}})',
    'import.importDialog.finish': 'Concluir',
  },
  en: {
    'import.importDialog.stepFile': 'File',
    'import.importDialog.stepMapping': 'Mapping',
    'import.importDialog.stepValidation': 'Validation',
    'import.importDialog.stepResult': 'Result',
    'import.importDialog.toastSuccess': 'Import complete: {{imported}} imported, {{updated}} updated.',
    'import.importDialog.toastNotCompleted': 'Import not completed.',
    'import.importDialog.title': 'Import {{label}}',
    'import.importDialog.dropzone': 'Drag the file here or click to choose',
    'import.importDialog.formats': 'CSV or XLSX',
    'import.importDialog.formatsStrict': 'CSV or XLSX — columns exactly in the template order',
    'import.importDialog.headerError': 'File does not match the import format.',
    'import.importDialog.expectedOrder': 'Expected order: {{order}}',
    'import.importDialog.downloadTemplateLabel': 'Download import template:',
    'import.importDialog.historyTitle': 'Import history',
    'import.importDialog.colDate': 'Date',
    'import.importDialog.colUser': 'User',
    'import.importDialog.colFile': 'File',
    'import.importDialog.colImported': 'Imported',
    'import.importDialog.colUpdated': 'Updated',
    'import.importDialog.colIgnored': 'Ignored',
    'import.importDialog.colRejected': 'Rejected',
    'import.importDialog.strictOk': 'File in the official format ({{count}} columns in the correct order) — mapping applied automatically.',
    'import.importDialog.mappingHint': 'Match each file column to a system field (suggestions already applied by name similarity).',
    'import.importDialog.colFileColumn': 'File column',
    'import.importDialog.colExample': 'Example (1st row)',
    'import.importDialog.colSystemField': 'System field',
    'import.importDialog.noTitle': '(no title)',
    'import.importDialog.mapColumnAria': 'Map column {{column}}',
    'import.importDialog.searchFieldPlaceholder': 'Search field…',
    'import.importDialog.optSkipColumn': 'Do not import this column',
    'import.importDialog.requiredDefaultsHint': 'Required fields without a column in the file — enter a default value for all rows:',
    'import.importDialog.defaultValueLabel': '{{field}} (default value)',
    'import.importDialog.sumTotalRows': 'Rows in file',
    'import.importDialog.sumValid': 'Valid',
    'import.importDialog.sumWithErrors': 'With errors',
    'import.importDialog.sumDuplicates': 'Duplicates',
    'import.importDialog.duplicatesLabel': 'Duplicate records ({{label}})',
    'import.importDialog.searchStrategyPlaceholder': 'Search strategy…',
    'import.importDialog.optStrategyIgnore': 'Ignore (keep the current record)',
    'import.importDialog.optStrategyUpdate': 'Update existing with the file data',
    'import.importDialog.optStrategyNew': 'Create new anyway',
    'import.importDialog.errorReport': 'Error report',
    'import.importDialog.errorsWarning': '{{count}} row(s) with problems will not be imported. Fix the file or allow importing only the valid ones.',
    'import.importDialog.colRow': 'Row',
    'import.importDialog.colField': 'Field',
    'import.importDialog.colProblem': 'Problem',
    'import.importDialog.errorsShowing': 'Showing {{shown}} of {{total}} errors — download the full report.',
    'import.importDialog.importValidOnly': 'Import only the {{count}} valid row(s) and reject the rest',
    'import.importDialog.previewTitle': 'Preview of what will be created',
    'import.importDialog.chipDuplicate': 'Duplicate',
    'import.importDialog.successAlert': 'Import complete.',
    'import.importDialog.notCompletedAlert': 'The import was not completed.',
    'import.importDialog.resImported': 'Imported',
    'import.importDialog.resUpdated': 'Updated',
    'import.importDialog.resIgnored': 'Ignored (duplicates)',
    'import.importDialog.resRejected': 'Rejected',
    'import.importDialog.downloadErrorReport': 'Download error report',
    'import.importDialog.validating': 'Validating…',
    'import.importDialog.validateData': 'Validate data',
    'import.importDialog.importing': 'Importing…',
    'import.importDialog.confirmImport': 'Confirm import ({{count}})',
    'import.importDialog.finish': 'Finish',
  },
  es: {
    'import.importDialog.stepFile': 'Archivo',
    'import.importDialog.stepMapping': 'Mapeo',
    'import.importDialog.stepValidation': 'Validación',
    'import.importDialog.stepResult': 'Resultado',
    'import.importDialog.toastSuccess': 'Importación completada: {{imported}} importado(s), {{updated}} actualizado(s).',
    'import.importDialog.toastNotCompleted': 'Importación no completada.',
    'import.importDialog.title': 'Importar {{label}}',
    'import.importDialog.dropzone': 'Arrastre el archivo aquí o haga clic para elegir',
    'import.importDialog.formats': 'CSV o XLSX',
    'import.importDialog.formatsStrict': 'CSV o XLSX — columnas exactamente en el orden de la plantilla',
    'import.importDialog.headerError': 'El archivo no cumple el formato de importación.',
    'import.importDialog.expectedOrder': 'Orden esperado: {{order}}',
    'import.importDialog.downloadTemplateLabel': 'Descargar plantilla de importación:',
    'import.importDialog.historyTitle': 'Historial de importaciones',
    'import.importDialog.colDate': 'Fecha',
    'import.importDialog.colUser': 'Usuario',
    'import.importDialog.colFile': 'Archivo',
    'import.importDialog.colImported': 'Importados',
    'import.importDialog.colUpdated': 'Actualizados',
    'import.importDialog.colIgnored': 'Ignorados',
    'import.importDialog.colRejected': 'Rechazados',
    'import.importDialog.strictOk': 'Archivo en el formato oficial ({{count}} columnas en el orden correcto) — mapeo aplicado automáticamente.',
    'import.importDialog.mappingHint': 'Asocie cada columna del archivo a un campo del sistema (sugerencias ya aplicadas por similitud de nombre).',
    'import.importDialog.colFileColumn': 'Columna del archivo',
    'import.importDialog.colExample': 'Ejemplo (1ª fila)',
    'import.importDialog.colSystemField': 'Campo del sistema',
    'import.importDialog.noTitle': '(sin título)',
    'import.importDialog.mapColumnAria': 'Mapear columna {{column}}',
    'import.importDialog.searchFieldPlaceholder': 'Buscar campo…',
    'import.importDialog.optSkipColumn': 'No importar esta columna',
    'import.importDialog.requiredDefaultsHint': 'Campos obligatorios sin columna en el archivo — indique un valor por defecto para todas las filas:',
    'import.importDialog.defaultValueLabel': '{{field}} (valor por defecto)',
    'import.importDialog.sumTotalRows': 'Filas del archivo',
    'import.importDialog.sumValid': 'Válidas',
    'import.importDialog.sumWithErrors': 'Con error',
    'import.importDialog.sumDuplicates': 'Duplicadas',
    'import.importDialog.duplicatesLabel': 'Registros duplicados ({{label}})',
    'import.importDialog.searchStrategyPlaceholder': 'Buscar estrategia…',
    'import.importDialog.optStrategyIgnore': 'Ignorar (mantener el registro actual)',
    'import.importDialog.optStrategyUpdate': 'Actualizar el existente con los datos del archivo',
    'import.importDialog.optStrategyNew': 'Registrar nuevo de todos modos',
    'import.importDialog.errorReport': 'Informe de errores',
    'import.importDialog.errorsWarning': '{{count}} fila(s) con problemas no se importarán. Corrija el archivo o autorice la importación solo de las válidas.',
    'import.importDialog.colRow': 'Fila',
    'import.importDialog.colField': 'Campo',
    'import.importDialog.colProblem': 'Problema',
    'import.importDialog.errorsShowing': 'Mostrando {{shown}} de {{total}} errores — descargue el informe completo.',
    'import.importDialog.importValidOnly': 'Importar solo las {{count}} fila(s) válida(s) y rechazar las demás',
    'import.importDialog.previewTitle': 'Vista previa de lo que se registrará',
    'import.importDialog.chipDuplicate': 'Duplicado',
    'import.importDialog.successAlert': 'Importación completada.',
    'import.importDialog.notCompletedAlert': 'La importación no se completó.',
    'import.importDialog.resImported': 'Importados',
    'import.importDialog.resUpdated': 'Actualizados',
    'import.importDialog.resIgnored': 'Ignorados (duplicados)',
    'import.importDialog.resRejected': 'Rechazados',
    'import.importDialog.downloadErrorReport': 'Descargar informe de errores',
    'import.importDialog.validating': 'Validando…',
    'import.importDialog.validateData': 'Validar datos',
    'import.importDialog.importing': 'Importando…',
    'import.importDialog.confirmImport': 'Confirmar importación ({{count}})',
    'import.importDialog.finish': 'Finalizar',
  },
}
